import QrFloatingButton from './QrFloatingButton';

export default QrFloatingButton;
